import { jarallax } from 'jarallax'

export default function init() {
  jarallax(document.querySelectorAll('.jarallax'), {
    speed: 0.1,
  })
}
